import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  perfilContainer: {
    padding: '16px 16px 16px 0',
    display: 'flex',
    flexDirection: 'row',

    '& .popup__box': {
      width: '100%',
      height: 'auto',
      maxWidth: '450px'
    }
  },

  customButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',

    gap: '16px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',

      '& button': {
        width: '100%'
      }
    }
  },

  propertiesTableActions: {
    width: '100%',
    display: 'flex',
    height: 5,
    '& img': {
      cursor: 'pointer'
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-around'
    }
  },
  perfilContainerContent: {
    width: '100%'
  },

  propertiesContainer: {
    height: '100%',
    position: 'relative',
    paddingRight: theme.app.spacing.base
  },

  propertiesDivider: {
    width: '100%'
  },

  propertiesHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: theme.app.spacing.base,
    '@media (min-width:356px)': {
      paddingRight: 0,
      display: 'inline-flex'
    }
  },

  propertiesTitle: {
    width: 100,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight
  },

  perfilSubTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.h3.fontSize,
    fontWeight: 500
  },

  userInicial: {
    color: theme.palette.secondary.main,
    width: '43px',
    height: '36px',
    display: 'flex',
    padding: '16px',
    fontSize: `${theme.app.typography.body.fontSize}px`,
    background: '#543936',
    alignItems: 'center',
    fontFamily: theme.app.typography.fontFamily.main,
    fontWeight: 700,
    marginRight: `${theme.app.spacing.sm}px`,
    borderRadius: `${theme.app.borderRadius.sm}px`,
    justifyContent: 'center'
  },

  perfilFieldset: {
    background: theme.app.colors.text.light,
    boxShadow: '0 2px 8px 0 rgba(120, 74, 66, 0.15)',
    padding: '24px',
    maxWidth: '330px',
    width: '100%',
    margin: '0 auto'
  },

  perfilFormItem: {
    marginBottom: '16px'
  },

  perfiLFormItemCenter: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '10px',
    textAlign: 'center'
  },

  perfilLabel: {
    color: theme.app.colors.text.primary,
    fontSize: `${theme.app.typography.label.fontSize}px`,
    display: 'block',
    lineHeight: '1em',
    marginBottom: '3px'
  },

  perfilInput: {
    background: `${theme.app.colors.input.background} no-repeat 94% center`,
    border: '0 none',
    padding: `${theme.app.spacing.md}px ${theme.app.spacing.base}px`,
    fontSize: `${theme.app.typography.body.fontSize}px`,
    color: theme.app.colors.text.primary,
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: `${theme.app.borderRadius.sm}px`,

    '&:disabled': {
      opacity: '.6'
    },

    '&:focus-visible': {
      border: '0 none',
      outline: '0 none'
    },

    '& input': {
      color: theme.app.colors.text.primary
    }
  },

  icoName: {
    backgroundImage: `url(${require('../../../assets/png/ico-id.png')})`
  },

  icoTel: {
    backgroundImage: `url(${require('../../../assets/png/ico-tel.png')})`
  },

  icoCpf: {
    backgroundImage: `url(${require('../../../assets/png/ico-cpf.png')})`
  },

  perfilButton: {
    width: 'fit-content',

    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },

  errorLabel: {
    color: theme.palette.primary.main,
    paddingBottom: '16px',
    fontSize: theme.app.typography.label.fontSize
  },

  popupChangePassword: {
    '& .popup__box': {
      maxWidth: '450px'
    }
  },

  popupChangePasswordIcon: {
    position: 'absolute',
    right: '8px',
    top: '60%',
    transform: 'translateY(-50%)',
    zIndex: 1
  },

  perfilButtonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    marginTop: '16px'
  }
}))
